<div class="col-lg-12 content-scroll-screen parent">
  <div class="row child">
    <p-card class="card-spacing-0">
      <span
        class="d-flex justify-content-between align-items-center p-3 globalborder-btm-header">
        <span class="col-auto">
          <h2 class="mb-0">Products</h2>
        </span>
        <span>
          <!-- <button
            type="button"
            class="btn btn-primary mb-3"
            (click)="showVariants()"
            *ngIf="
              selectedProductsListing &&
              selectedProductsListing?.productTypeD365 === 'Item'
            "></button> -->

          <p-button
            label="View Variants"
            (click)="showVariants()"
            *ngIf="
              selectedProductsListing &&
              selectedProductsListing?.productTypeD365 === 'Item'
            " />
        </span>
      </span>
      <div class="col-lg-12 adduser-container-hgt">
        <p-table
          #dt
          stripedRows
          [rowHover]="true"
          [size]="'small'"
          responsiveLayout="scroll"
          [value]="filterProductsListing"
          scrollHeight="calc(100vh - 255px)"
          [(selection)]="selectedProductsListing"
          styleClass="p-datatable-customers ordersListing search-more"
          [rowHover]="true"
          [rows]="50"
          [showCurrentPageReport]="true"
          [rowsPerPageOptions]="[10, 20, 50, 250, 1000]"
          [paginator]="true"
          [filterDelay]="0"
          selectionMode="single"
          sortMode="multiple"
          styleClass="table-listing popuptable">
          <ng-template pTemplate="header">
            <tr class="table-head">
              <th></th>
              <th style="width: 3rem" pSortableColumn="itemNumberD365">
                Item number <p-sortIcon field="itemNumberD365"></p-sortIcon>
              </th>
              <th class="status" pSortableColumn="nameD365">
                Product name
                <p-sortIcon field="nameD365"></p-sortIcon>
              </th>
              <th class="status" pSortableColumn="productTypeD365">
                Product type
                <p-sortIcon field="productTypeD365"></p-sortIcon>
              </th>
              <!-- <th class="name" pSortableColumn="productSubTypeD365">
        Product subtype
        <p-sortIcon field="productSubTypeD365"></p-sortIcon>
      </th> -->
            </tr>
            <tr>
              <th></th>
              <th>
                <div class="d-flex">
                  <input
                    jniAutoCompleteBlocker
                    pInputText
                    type="text"
                    name="itemNumberD365
"
                    id="itemNumberD365
"
                    (input)="
                      dt.filter(
                        $any($event.target).value,
                        'itemNumberD365',
                        'contains'
                      )
                    "
                    placeholder=""
                    class="p-column-filter p-inputtext p-component" />
                </div>
              </th>
              <th>
                <div class="d-flex">
                  <input
                    jniAutoCompleteBlocker
                    pInputText
                    type="text"
                    name="nameD365"
                    id="nameD365"
                    (input)="
                      dt.filter(
                        $any($event.target).value,
                        'nameD365',
                        'contains'
                      )
                    "
                    placeholder=""
                    class="p-column-filter p-inputtext p-component" />
                </div>
              </th>
              <th>
                <div class="d-flex">
                  <input
                    jniAutoCompleteBlocker
                    pInputText
                    type="text"
                    name="productTypeD365"
                    id="productTypeD365"
                    (input)="
                      dt.filter(
                        $any($event.target).value,
                        'productTypeD365',
                        'contains'
                      )
                    "
                    placeholder=""
                    class="p-column-filter p-inputtext p-component" />
                </div>
              </th>
              <!--<th>
                <div class="d-flex">
          <input
            jniAutoCompleteBlocker
            pInputText
            type="text"
            name="productSubTypeD365"
            id="productSubTypeD365"
            
            (input)="
              dt.filter(
                $any($event.target).value,
                'productSubTypeD365',
                'contains'
              )
            "
            placeholder=""
            class="p-column-filter p-inputtext p-component"
          />
        </div> 
              </th>-->
            </tr>
          </ng-template>
          <ng-template
            pTemplate="body"
            let-productsListing
            let-rowIndex="rowIndex">
            <tr
              class="p-selectable-row"
              [pSelectableRow]="productsListing"
              [pSelectableRowIndex]="rowIndex">
              <td class="col-center">
                <p-tableCheckbox
                  class=""
                  [value]="productsListing"
                  [pSelectableRow]="productsListing"></p-tableCheckbox>
              </td>
              <td>
                <a
                  class="link"
                  (click)="redirectToProductSummary(productsListing)">
                  {{ productsListing.itemNumberD365 }}</a
                >
              </td>
              <td>
                {{ productsListing.nameD365 }}
              </td>
              <td>
                {{ productsListing.productTypeD365 }}
              </td>
              <!-- <td>
        {{ productsListing.productSubTypeD365 }}
      </td> -->
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="20">No products found.</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </p-card>
  </div>
</div>

<jni-modal-stacker
  class="modal-header-sticky"
  *ngIf="productDetailModal"
  [displayModal]="productDetailModal"
  (closeEvent)="closeModalForProductDetail()">
  <h1 class="panelHeading">{{ modalReleasedStoreProducts.itemNumberD365 }}</h1>
  <div class="panelBody">
    <jni-product-summary
      [productSummaryDetail]="modalReleasedStoreProducts"
      (closeModalEvent)="closeModalForProductDetail()"></jni-product-summary>
  </div>
</jni-modal-stacker>

<jni-modal-stacker
  class="modal-header-sticky"
  *ngIf="variantsListingModal"
  [displayModal]="variantsListingModal"
  (closeEvent)="closeModalForVariantsListing()">
  <h1 class="panelHeading">Variants</h1>
  <div class="panelBody">
    <jni-variants-listing
      [itemNumber]="selectedVariantItemNumber"
      [productName]="selectedProductsListing.nameD365 || ''"
      (closeModalEvent)="closeModalForVariantsListing()"></jni-variants-listing>
  </div>
</jni-modal-stacker>
